import React, { FC, Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useField } from 'formik';
import { Box, Grid, Switch, Typography } from '@material-ui/core';

import { SocialAccount } from 'api';
import { useShareCopy } from 'hooks';
import { SocialIcon, ValidatedTextFieldNext } from 'components';
import { getSocialAccountName } from 'helpers';

import { ShareItem } from '../../types';
import Count from '../Count';

interface Props {
  index: number;
}

const PartnerShareConnected: FC<Props> = ({ index }) => {
  const { t } = useTranslation();
  const { networkShareCopyIndex, networkCommentaries } = useShareCopy();

  const [field, , helpers] = useField<ShareItem>(`items.${index}`);
  const { name, value, onChange } = field;
  const { active, networkMeta, socialAccount } = value.state;

  useEffect(() => {
    const loadValues = {
      ...value,
      user_commentary: networkCommentaries[networkShareCopyIndex]?.commentary ?? '',
    };

    helpers.setValue(loadValues);
  }, []);

  return (
    <Fragment>
      <Grid container alignItems="center" spacing={2}>
        <Grid item>
          <SocialIcon state={active ? 'active' : 'disabled'} provider={networkMeta.provider} />
        </Grid>
        <Grid item xs>
          <Typography variant="subtitle2">
            {getSocialAccountName(socialAccount as SocialAccount)}
          </Typography>
        </Grid>
        <Grid item>
          <Switch name={`${name}.state.active`} checked={active} onChange={onChange} />
        </Grid>
      </Grid>
      <Box marginTop={2}>
        <ValidatedTextFieldNext
          label={null}
          placeholder={t(`sharing:${networkMeta.provider}`)}
          name={`${name}.user_commentary`}
          multiline
          rows={4}
          variant={'outlined' as any}
          fullWidth
        />
      </Box>
      <Box marginTop={0.5}>
        <Count index={index} />
      </Box>
    </Fragment>
  );
};

export default PartnerShareConnected;
